import './LicenseConcepts.scss';

import type { FC } from 'react';

import { FontLicenseType } from 'client/graphql/types/operations';

import useCart from './utils/useCart';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface Props {
  family: {
    id: number;
    name: string;
    conceptFont: boolean;
    completePrice: number;
    fontFacePrice: number;
    subPackageFontFacePrice: number;
    discountedFontFacePrice: number;
    faces: {
      id: number;
      width: { slug: string; name: string; position: number };
      size: { slug: string; name: string; position: number };
      weight: { slug: string; name: string; position: number };
      style: { slug: string; name: string; position: number };
      description: string;
      familyPreview: { url: string | null };
      singlePreview: { url: string | null };
      singleCharacterPreview: {
        url: string | null;
      };
      family: { fontFacePrice: number; discountedFontFacePrice: number };
    }[];
  };
  licenseOption: {
    id: number;
    type: FontLicenseType;
    multiplier: number;
  } | null;
}

const LicenseConcepts: FC<Props> = (props) => {
  const { family, licenseOption } = props;
  const { faces } = family;

  const { t } = useTranslation();

  const { allFacesInOrder, toggleFaces } = useCart({
    licenseOption,
    family,
    faces,
  });

  return (
    <div className="FamiliesLicenseConcepts">
      <div className="FamiliesLicenseConcepts-standard">
        <div className="FamiliesLicenseConcepts-description">
          <p>{t('family.concepts.pricingDescription')}</p>
        </div>

        <button
          className={classNames('FamiliesLicenseConcepts-licenseButton', {
            'FamiliesLicenseConcepts-licenseButton--selected': allFacesInOrder,
          })}
          onClick={toggleFaces}
        >
          {t('family.concepts.freeLicense')}
        </button>
      </div>

      <div className="FamiliesLicenseConcepts-paid">
        <div className="FamiliesLicenseConcepts-description">
          <p>{t('family.concepts.paidLicense', { familyName: family.name })}</p>
        </div>

        <a
          className="FamiliesLicenseConcepts-contactButton"
          href="mailto:info@kilotype.de"
        >
          {t('family.concepts.contactUs')}
        </a>
      </div>
    </div>
  );
};

export default LicenseConcepts;
